export default __webpack_public_path__ + "static/media/drought.21676302.svg";